import React from 'react'
import Data from './data.json'

// import FormValidationScreen from '../FormValidationScreen/FormValidationScreen'
import MoveForm from '../MoveForm/MoveForm'
import * as S from './FormContainer.style'

const FormContainer = ({ isLogicImmo }) => {
  const content = (
    <>
      <S.StyledBackground>
        <S.StyledFormContainer>
          <S.StyledFormLeftContainer>
            <S.StyledTitle>
              Organisez aujourd’hui <br />
              votre déménagement de demain
            </S.StyledTitle>

            <S.StyledRemise>5% de remise avec le code</S.StyledRemise>
            <S.StyledRemise>{isLogicImmo ? 'LOGICIMMO5' : 'SELOGER5'}</S.StyledRemise>
          </S.StyledFormLeftContainer>
          <S.StyledFormSection id="form-section">
            <MoveForm isLogicImmo={isLogicImmo} />
          </S.StyledFormSection>
        </S.StyledFormContainer>
      </S.StyledBackground>

      <S.StyledInfoContainer>
        <ul>
          {Data.infoItem.map(val => (
            <S.StyledInfoItem key={val.smallText} isLogicImmo={isLogicImmo}>
              <span>{val.bigText}</span>
              {val.smallText}
            </S.StyledInfoItem>
          ))}
        </ul>
      </S.StyledInfoContainer>
    </>
  )
  return content
}

export default FormContainer
